import { render } from "./PatientsManager.vue?vue&type=template&id=b905dee8&scoped=true"
import script from "./PatientsManager.vue?vue&type=script&lang=js"
export * from "./PatientsManager.vue?vue&type=script&lang=js"

import "./PatientsManager.vue?vue&type=style&index=0&id=b905dee8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b905dee8"]])

export default __exports__